module.exports = __webpack_public_path__ + "static/media/icon.35b85499.png";